import * as React from "react";
import { Helmet } from "react-helmet";

export default class PrivacyPage extends React.Component {
    
    render() {
        
        return <div className="ll-help-content">

<Helmet>
    <title>Privacy policy</title>
</Helmet>

<h1>Privacy policy</h1>

<h2>Data processed</h2>

<p>When you interact with this website, we collect the following information:</p>

<ul>
    <li>IP address</li>
    <li>Browser identification</li>
    <li>Which jobs you calculated</li>
    <li>Date and time of visit</li>
    <li>Type of your operating system</li>
    <li>E-mail address provided during job submission (optional)</li>
</ul>

<h2>Data controller</h2>

<p>The controller of the above listed data is Loschmidt Laboratories, Department of Experimental Biology and RECETOX, Faculty of Science, Masaryk University, Kotlarska 267/2, 611 37 Brno, Czech Republic (further referred to as LL).</p>

<h2>Reason for personal data processing</h2>

<p>Personal data related to the usage of the website (traffic and location) are being processed for the purpose of:</p>

<ul>
    <li>Statistics</li>
    <li>Service monitoring</li>
    <li>Optimisation of partial tasks</li>
    <li>Notification of job status</li>
    <li>Security</li>
    <li>Drafting annual reports, monitoring reports, project result summaries and other similar documents for the purpose-built support providers</li>
    <li>provide information about commercial licenses</li>
</ul>

<h2>Third party disclosure</h2>

<p>We do not disclose any data about website users to third parties.</p>

<h2>Data retention</h2>

<p>Personal data are stored for the period set by individual providers of purpose-built support provided to LL, with the minimum period of 5 years after the projects had been terminated.</p>

<p>If you do not wish LL to process your data related to this website usage, please do not use this website.</p>

        </div>
    }
}
